import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { fadeInUp, standardViewport } from '../../utils/animation';
import './AboutHeader.scss';

const AboutHeader = () => {
  const { t } = useTranslation('about');
  
  return (
    <section className="about-header">
      <motion.h1 
        className="about-header__title"
        initial="hidden"
        whileInView="visible"
        viewport={standardViewport}
        variants={fadeInUp}
      >
        {t('header.title')}
      </motion.h1>
    </section>
  );
};

export default AboutHeader;
